import React, { useEffect } from "react";
import { Layout } from "components/layout";
import { useNavigate } from "react-router-dom";
import "./LandingPrincipal.css";
import { Hero } from "./components/Hero";
import { Features } from "./components/Features";
import { Process } from "./components/Process";
export const LandingPrincipal = () => {
  const navigate = useNavigate();

  const handleLoginClick = () => {
    navigate("/sign-in");
  };



  const scrollToFeatures = () => {
    document.getElementById("features")?.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <Layout>
      <div className="landing-page">
        <Hero handleLoginClick={handleLoginClick} scrollToFeatures={scrollToFeatures} />
        <Features />
        <Process />
      </div>
    </Layout>
  );
};
